import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import { AdditionalInfo, CoordinateInfo, LayoverInfo } from '.';
import { JourneyParts } from 'types/shared';

interface JourneyPartProps {
  journeyParts: JourneyParts;
  journeyIndex: number;
  journeyInfoRef?: React.RefObject<HTMLDivElement>;
}

export const JourneyPart = ({ journeyParts, journeyIndex, journeyInfoRef }: JourneyPartProps) => {
  const { flightsConnectionInformation, connectionAdditionalInformation } = journeyParts;
  const { flightsConnection } = flightsConnectionInformation;

  return (
    <UitkSpacing padding={{ inlineend: 'one' }}>
      <div data-test-id={`journey-part-${journeyIndex}`} ref={journeyInfoRef} tabIndex={-1}>
        <CoordinateInfo
          coordinateInformation={flightsConnection.connectionDeparture}
          dataTestId={`departure-coordinate-${journeyIndex}`}
        />

        <AdditionalInfo flightsConnection={flightsConnection} dataTestId={`additional-info-${journeyIndex}`} />

        <CoordinateInfo
          coordinateInformation={flightsConnection.connectionArrival}
          dataTestId={`arrival-coordinate-${journeyIndex}`}
        />

        {connectionAdditionalInformation && (
          <LayoverInfo
            connectionAdditionalInformation={connectionAdditionalInformation}
            dataTestId={`layover-info-${journeyIndex}`}
          />
        )}

        {flightsConnectionInformation.governmentApprovalMessage && (
          <UitkText
            size={300}
            theme="negative"
            className="all-l-padding-six all-t-padding-six"
            dataTestId={`government-approval-message-${journeyIndex}`}
          >
            {flightsConnectionInformation.governmentApprovalMessage}
          </UitkText>
        )}
      </div>
    </UitkSpacing>
  );
};
